import { Outlet } from '@tanstack/react-router';
import { AdminLayout } from '../components/admin-layout.js';
import { useStaffSession } from '../hooks/use-staff-session.js';

/* Wrapper das rotas autenticadas: o `beforeLoad` da rota já garantiu sessão e
   hidratou o store, então aqui só lemos a metadata para montar o shell. */
export function AuthenticatedLayout() {
  const session = useStaffSession();
  if (session === null) {
    return null;
  }
  return (
    <AdminLayout session={session}>
      <Outlet />
    </AdminLayout>
  );
}
